import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Badge, Button, Modal } from "react-bootstrap";
import HtmlParser, { domToReact } from "html-react-parser";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { get } from "../../../utils/DeApi";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import CatalogueAdd from "../../Catalogue/CatalogueAdd/CatalogueAdd";
import CatalogueRemove from "../../Catalogue/CatalogueRemove/CatalogueRemove";

class OptimizedFilingPreview extends Component {
  constructor(props) {
    super(props);
    this.state = { doc: props.doc };
    this.subscribedPromises = [];
  }

  componentDidMount() {
    this.fetchDocument();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.doc.documentUrl !== this.props.doc.documentUrl) {
      this.setState({ doc: this.props.doc }, this.fetchDocument());
    }
  }

  fetchDocument() {
    this.setState({ error: null, isLoading: true });
    const { doc } = this.state;
    const { filing } = this.props;

    let documentUrl =
      "https://dealsense-filing.s3.us-west-2.amazonaws.com/" +
      filing.filedAt.split("T").shift() +
      "/" +
      filing.accessionNo +
      "/" +
      doc.documentUrl.split("/").pop();

    axios
      .get(documentUrl)
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.fetchDocumentLegacy();
      });
  }

  fetchDocumentLegacy() {
    this.setState({ docContents: null, error: null, isLoading: true });
    const { doc } = this.state;
    const { filing } = this.props;

    const fetchDocumentPromise = get(`filings/${filing.accessionNo}/document`, {
      params: { type: doc.type.trim() },
    });

    fetchDocumentPromise.promise
      .then((response) => {
        this.setState({
          docContents: this.parseHTML(response.data),
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
  }

  parseHTML(html) {
    const { filing } = this.props;
    const options = {
      replace: ({ name, children, attribs }) => {
        if (name === "font") {
          return (
            <font style={{ fontSize: 12 }}>
              {domToReact(children, options)}
            </font>
          );
        }

        if (name === "a") {
          return (
            <a
              href={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.href}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {domToReact(children, options)}
            </a>
          );
        }

        if (name === "img") {
          return (
            <img
              alt={attribs.alt || filing.accessionNo}
              src={`https://www.sec.gov/Archives/edgar/data/${
                filing.cik
              }/${filing.accessionNo.replace(/-/gi, "")}/${attribs.src}`}
            />
          );
        }
      },
    };

    try {
      return ReactDOMServer.renderToString(HtmlParser(html, options));
    } catch (e) {
      return html;
    }
  }

  render() {
    const { doc, docContents, isLoading, error } = this.state;
    const { filing, onDocumentClosed, onCatalogueAdd } = this.props;
    return (
      <div>
        <Modal
          size="xl"
          show={!!filing}
          animation={false}
          onHide={onDocumentClosed}
          backdrop={"static"}
          scrollable={"true"}
        >
          <Modal.Header closeButton>
            <Modal.Title as="div">
              <h3 className="mb-0">
                {filing?.companyNameLong},{" "}
                <strong variant="info">{doc.type}</strong>
              </h3>
            </Modal.Title>
            {onCatalogueAdd && (
              <span className="ml-auto mr-3">{this.renderCataloging()}</span>
            )}
          </Modal.Header>
          <Modal.Body className="scrollControl responsive-width">
            {isLoading && <Loader />}
            {error && <ErrorHandler error={error} />}
            {docContents && (
              <div dangerouslySetInnerHTML={{ __html: docContents }} />
            )}
          </Modal.Body>
          <Modal.Footer>{this.renderFooter()}</Modal.Footer>
        </Modal>
      </div>
    );
  }

  renderCataloging() {
    const { filing, selections, onCatalogueAdd, onCatalogueRemove, user } =
      this.props;

    const { doc } = this.state;
    var catalogued = selections.find(
      (item) =>
        item.filingId === filing.accessionNo &&
        item.exhibit === doc.type &&
        doc.documentId === item.documentId
    );

    if (catalogued) {
      return (
        <CatalogueRemove
          catalogued={catalogued}
          user={user}
          onFilingRemoved={onCatalogueRemove}
          screen={`filing`}
          show={this.props.btnShow}
        />
      );
    }
    return (
      <CatalogueAdd
        doc={doc}
        filing={filing}
        user={user}
        onFilingAdded={onCatalogueAdd}
        screen={`filing`}
        show={this.props.btnShow}
      />
    );
  }

  renderFooter() {
    const { catalogue, selections, filing, onDocumentClosed } = this.props;
    const { doc } = this.state;
    const filingDocs = filing.documentFormatFiles.filter(
      (item) =>
        item.type === filing.formType || item.type.toLowerCase().includes("ex")
    );
    var indexOfCurr = filingDocs.findIndex(
      (item) => item.sequence === doc.sequence
    );

    return (
      <Fragment>
        <p className="modal-footer-block mr-auto customScroller scrollControl">
          {filingDocs.map((item, index) => {
            var isSelected = selections.find(
              (catalogued) =>
                catalogued.filingId === filing.accessionNo &&
                catalogued.exhibit === item.type &&
                catalogued.documentId === item.documentId
            );

            var inventories = catalogue
              .filter((catalogued) => {
                if (
                  catalogued.filingId === filing.accessionNo &&
                  catalogued.exhibit === item.type &&
                  item.documentId === doc.documentId
                ) {
                  return catalogued;
                }
              })
              .map((item) => item.inventory)
              .flat();

            inventories = inventories.filter(
              (item, index, self) =>
                self.findIndex((inventory) => inventory.id === item.id) ===
                index
            );
            return (
              <Button
                key={index}
                variant={""}
                disabled={item.documentUrl === doc.documentUrl}
                size="sm"
                className={`mr-1 color-deal-style-anchor ${
                  isSelected
                    ? "btn-success-deal-style color-deal-font roundedEdges"
                    : inventories?.length
                    ? "btn-outline-deal-style roundedEdges"
                    : "btn-link"
                }`}
                onClick={() => {
                  this.setState({ doc: item }, () => this.fetchDocument());
                }}
              >
                {item.type}
                {inventories.map((item, index) => (
                  <Badge
                    variant="dark"
                    size="sm"
                    className="ml-1 mr-1"
                    key={index}
                    title={item.name}
                  >
                    {item.name.match(/\b(\w)/g).join("")}
                  </Badge>
                ))}
              </Button>
            );
          })}
        </p>

        <Button
          size="lg"
          variant="link"
          className="color-deal-style"
          disabled={indexOfCurr - 1 < 0}
          onClick={() => {
            this.setState({ doc: filingDocs[indexOfCurr - 1] }, () =>
              this.fetchDocument()
            );
          }}
        >
          <span className="material-icons">navigate_before</span>
        </Button>
        <Button
          size="lg"
          variant="link"
          className="color-deal-style"
          disabled={indexOfCurr + 1 >= filingDocs.length}
          onClick={() => {
            this.setState({ doc: filingDocs[indexOfCurr + 1] }, () =>
              this.fetchDocument()
            );
          }}
        >
          <span className="material-icons">navigate_next</span>
        </Button>
        <a
          className="btn btn-link color-deal-style"
          target="_blank"
          rel="noreferrer"
          href={`https://www.sec.gov/Archives/edgar/data/${
            filing.cik
          }/${filing.accessionNo.replace(/-/gi, "")}/${
            filing.accessionNo
          }-index.html`}
        >
          <span className="material-icons">launch</span>
        </a>

        <Button
          variant="default"
          className="roundedEdges btn-success-deal-style"
          onClick={onDocumentClosed}
        >
          Close
        </Button>
      </Fragment>
    );
  }
}

OptimizedFilingPreview.propTypes = {
  doc: PropTypes.object.isRequired,
  filing: PropTypes.object.isRequired,
  catalogue: PropTypes.array.isRequired,
  selections: PropTypes.array.isRequired,
  btnShow: PropTypes.bool.isRequired,
  onDocumentClosed: PropTypes.func.isRequired,

  onCatalogueAdd: PropTypes.func,
  onCatalogueRemove: PropTypes.func,
};

export default OptimizedFilingPreview;
